const colors = {
    primary: "#11345f",
    secondary: "#b69050"
};

export default colors;